import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom'
import { API_PATH } from '../../../Constant/constants';

const InventoryPage = () => {
  const [transactions, setTransactions] = useState([]);
  const [stocks, setStocks] = useState([]);
  const [medicines, setMedicines] = useState([]);
const [users, setUsers] = useState([]);

  const [formData, setFormData] = useState({
    medicineId: '',
    medicineName: '',
    transactionType: 'IN',
    quantity: '',
    userId: '',
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTransactions();
    fetchAllStock();
    fetchMedicines();
    fetchUsers();
  }, []);
  
  const fetchMedicines = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await axios.get(`${API_PATH}/medicines`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setMedicines(response.data);
    } catch (error) {
      console.error('Error fetching medicines:', error);
    }
  };
  
  const fetchUsers = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await axios.get(`${API_PATH}/users`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUsers(response.data);
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };
  

  const fetchTransactions = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await axios.get(`${API_PATH}/inventory/transaction`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setTransactions(response.data);
    } catch (error) {
      console.error('Error fetching transactions:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchAllStock = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await axios.get(`${API_PATH}/inventory/stock/all`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setStocks(response.data);
    } catch (error) {
      console.error('Error fetching stock:', error);
    }
  };

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('authToken');
    try {
      await axios.post(`${API_PATH}/inventory/transaction`, formData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      alert('✅ Inventory transaction added!');
      fetchTransactions();
      fetchAllStock();
      setFormData({
        medicineId: '',
        medicineName: '',
        transactionType: 'IN',
        quantity: '',
        userId: '',
      });
    } catch (error) {
      console.error('Error submitting transaction:', error);
      alert('❌ Failed to submit');
    }
  };

  return (
    <div className="container mt-4 w-100 mw-100 h-100 mb-5" style={{overflowY:"scroll"}}>
      <h4>📦 Inventory Management</h4>

      <form onSubmit={handleSubmit} className="row g-3 border p-3 mt-3 rounded">
        <h4>Add New Transaction</h4>
        <div className="col-md-4">
        
            <select
              name="medicineId"
              value={formData.medicineId}
              onChange={(e) => {
                const selectedMed = medicines.find(m => m.id === parseInt(e.target.value));
                setFormData(prev => ({
                  ...prev,
                  medicineId: e.target.value,
                  medicineName: selectedMed ? selectedMed.name : '',
                }));
              }}
              className="form-control"
              required
            >
              <option value="">-- Select Medicine --</option>
              {medicines.map((med) => (
                <option key={med.id} value={med.id}>
                  {med.name} (ID: {med.id})
                </option>
              ))}
            </select>
        </div>
        <div className="col-md-3">
          <input type="text" name="medicineName" placeholder="Medicine Name" value={formData.medicineName} onChange={handleChange} className="form-control" required />
        </div>
        <div className="col-md-2">
          <select name="transactionType" value={formData.transactionType} onChange={handleChange} className="form-select">
            <option value="IN">IN</option>
            <option value="OUT">OUT</option>
          </select>
        </div>
        <div className="col-md-2">
          <input type="number" name="quantity" placeholder="Quantity" value={formData.quantity} onChange={handleChange} className="form-control" required />
        </div>
        <div className="col-md-2">
            <select
              name="userId"
              value={formData.userId}
              onChange={handleChange}
              className="form-control"
              required
            >
              <option value="">-- Select User --</option>
              {users.map((user) => (
                <option key={user.id} value={user.id}>
                  {user.fullName} (ID: {user.id})
                </option>
              ))}
            </select>

        </div>
        <div className="col-md-12 text-end">
          <button className="btn btn-color">Submit</button>
        </div>
      </form>

      <hr />
<div className='container w-100 mw-100'>
      <h4 className="mt-4">💊 Current Stock (All Medicines)</h4>
      <table className=" table-bordered table-striped">
        <thead className="tableborder">
          <tr>
            <th>Medicine ID</th>
            <th>Medicine Name</th>
            <th>Current Stock</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {stocks.map((stock, index) => (
            <tr key={index} className="datahover">
              <td>{stock.medicineId}</td>
              <td>{stock.medicineName}</td>
              <td>{stock.currentStock}</td>
              <td> <Link to={`/admin/home/medicines/stock/${stock.medicineId}`} className='btn-color text-white px-2 py-2 rounded text-decoration-none'>Medicine Stock</Link></td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
       <div className='container w-100 mw-100 m-0'>
      <h4 className="mt-5">📑 Inventory Transactions</h4>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <div className=' h-100 mh-100 '>
        <div className='table table-responsive'>
        <table className=" table-bordered  mt-3">
          <thead className="tableborder">
            <tr>
              <th>ID</th>
              <th>Medicine Name</th>
              <th>Type</th>
              <th>Quantity</th>
              <th>Date</th>
              <th>User ID</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {transactions.map((tx) => (
              <tr key={tx.id} className='datahover'>
                <td>{tx.id}</td>
                <td>{tx.medicineName}</td>
                <td>{tx.transactionType}</td>
                <td>{tx.quantity}</td>
                <td>{new Date(tx.transactionDate).toLocaleString()}</td>
                <td>{tx.userId}</td>
                <td> <Link to={`/admin/home/medicines/transaction/${tx.medicineId}`} className='btn-color text-white px-2 py-2 rounded text-decoration-none'>Medicine Transaction</Link></td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
        </div>
      )}
    </div>
    </div>
  );
};

export default InventoryPage;
